import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './app/routes';
import { LegacyHashRouteBridge } from './app/LegacyHashRouteBridge';
import { ScrollToTop } from './utils/ScrollToTop';
import './styles';

function App() {
  return (
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <LegacyHashRouteBridge />
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
